import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'LexCore',
  brandName: 'LexCore',
  description: 'Sistema de agendamento para advogados',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Escritório de advocacia',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Advogado em reunião com cliente',
  },
  testimonials: [
    {
      name: 'Dr.ª Rita Moreira',
      role: 'Advogada',
      text: 'O LexCore é uma ferramenta indispensável para a gestão das minhas consultas. Confidencial e eficiente.',
      image: testimonial1,
    },
    {
      name: 'João Neves',
      role: 'Cliente',
      text: 'Marcar uma reunião com a minha advogada tornou-se um processo muito mais simples e discreto.',
      image: testimonial2,
    },
    {
      name: 'Moreira & Associados',
      role: 'Sociedade de Advogados',
      text: 'A organização e o agendamento de todos os nossos advogados melhoraram significativamente.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'advogado',
    professionals: 'advogados',
    business: 'escritório',
    businesses: 'escritórios',
    service: 'consulta',
    services: 'consultas',
    client: 'cliente',
    clients: 'clientes',
    appointment: 'reunião',
    appointments: 'reuniões',
  },
  homepage: {
    hero: {
      badge: 'Solução Jurídica',
      title: 'Profissionalismo e eficiência com LexCore',
      description: 'Otimize a gestão do seu escritório de advocacia e ofereça excelência no atendimento aos seus clientes.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Confidencialidade garantida', 'Configuração profissional'],
    },
    statistics: [
      { value: '250+', label: 'Escritórios' },
      { value: '22k+', label: 'Consultas' },
      { value: '99%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Interrupções Durante Consultas',
        description: 'Atender telefone durante reuniões jurídicas compromete a confidencialidade e concentração.',
        icon: 'PhoneCall',
        quote: {
          text: 'Com o LexCore, eliminei as interrupções por telefone e posso focar 100% no caso do cliente',
          author: 'Dr. Carlos Martins',
          business: 'Martins Advocacia',
        },
      },
      {
        title: 'Conflitos de Agenda',
        description: 'Marcações duplas e conflitos de horário prejudicam a imagem profissional do escritório.',
        icon: 'Calendar',
        stats: [
          { label: 'Conflitos por semana:', value: '8+' },
          { label: 'Tempo perdido reorganizando:', value: '6 horas' },
        ],
      },
      {
        title: 'Gestão de Casos Complexa',
        description: 'Acompanhar prazos, audiências e reuniões sem um sistema adequado pode gerar erros críticos.',
        icon: 'Scale',
        quote: {
          text: 'O sistema me ajuda a nunca perder um prazo importante. A organização melhorou 90%',
          author: 'Dr.ª Ana Santos',
          business: 'Santos & Parceiros',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'LexCore: Excelência jurídica digitalizada',
      description: 'Uma plataforma segura e profissional pensada especificamente para as necessidades da advocacia.',
      features: [
        {
          title: 'Agendamento Confidencial',
          description: 'Sistema seguro que respeita a confidencialidade advogado-cliente.',
        },
        {
          title: 'Gestão de Casos',
          description: 'Organize processos, prazos e reuniões de forma profissional.',
        },
        {
          title: 'Lembretes de Prazos',
          description: 'Nunca perca um prazo importante com notificações automáticas.',
        },
      ],
    },
    testimonials: {
      title: 'O que os advogados dizem',
      description: 'Profissionais do direito que confiam no LexCore para excelência jurídica.',
    },
    finalCta: {
      title: 'Pronto para modernizar seu escritório?',
      description: 'Junte-se aos advogados que já elevaram o nível do seu atendimento com LexCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Falar com Consultor Jurídico',
    },
    contact: {
      title: 'Contacte-nos',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de advogado',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
